import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHistoryComponent } from "./med-icon-history.component";

@NgModule({
  declarations: [
    MedIconHistoryComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHistoryComponent,
  ],
})
export class MedIconHistoryModule { }
